export default "__VITE_ASSET__BLhT4AJ9__"